import React from 'react';

const BS_Certificate = () => {
    return (
        <div>
            <h1>BS_Certificate Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Certificate;
